module.exports = __webpack_public_path__ + "static/media/STS Shuttle Loading and Rail Safety - Script_1718730149414.282e0134.docx";